var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8335 2.33325L14.0002 8.16659L8.16683 2.33325M4.66683 8.16659H23.3335C24.6222 8.16659 25.6668 9.21125 25.6668 10.4999V23.3333C25.6668 24.6219 24.6222 25.6666 23.3335 25.6666H4.66683C3.37817 25.6666 2.3335 24.6219 2.3335 23.3333V10.4999C2.3335 9.21125 3.37817 8.16659 4.66683 8.16659Z",
    stroke: "currentColor",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.9a22ab8e34eedf5bbaf37fcef1bf646d.svg";
export { ForwardRef as ReactComponent };